import React from "react";
import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor/dist/i18n/ko-kr";
import { TextViewerStyle } from "./TextViewer.styled";
import useEmotionStyles from "@styles/shared/useEmotionStyles";

type Props = {
	currentHTML: string;
	height?: number;
}

function TextViewer(props: Props) {
	const {
		currentHTML,
		height = 300
	} = props;
	const classes = useEmotionStyles(TextViewerStyle);

	const viewerRef = React.useRef<any>(null);

	React.useEffect(() => {
		if (
			!viewerRef.current
			|| !currentHTML
		)
			return;

		viewerRef.current.getInstance().setMarkdown(currentHTML);
	}, [viewerRef.current, currentHTML]);

	React.useEffect(() => {
		return () => {
			viewerRef.current = null;
		}
	}, []);

	return (
		<div className={classes.main}>
			<Viewer
				ref={viewerRef}
			/>
		</div>
	);
}

export default TextViewer;
